export { EthSecp256k1Wallet as InjectiveEthSecp256k1Wallet } from './EthSecp256k1Wallet';
export { DirectEthSecp256k1Wallet as InjectiveDirectEthSecp256k1Wallet } from './DirectEthSecp256k1Wallet';
//# sourceMappingURL=index.js.map